import { QueryClient, QueryClientProvider, QueryCache } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { Toaster } from 'sonner';
import './lib/i18n';
import { routeTree } from './routeTree.gen';
import { useAuthStore } from './stores/authStore';
import { SessionExpiredError, ApiError } from './api/errors';

const router = createRouter({
    routeTree,
    context: {
        auth: { ensureLoaded: () => useAuthStore.getState().ensureLoaded() },
    },
    defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router;
    }
}

// DEC-008: captura de SessionExpiredError via QueryCache.onError + mutations.onError. Ver DECISIONES.md.
const queryClient = new QueryClient({
    queryCache: new QueryCache({
        onError: (error) => {
            if (error instanceof SessionExpiredError) {
                useAuthStore.getState().clear();
                void router.navigate({ to: '/login' });
            }
        },
    }),
    defaultOptions: {
        queries: {
            retry: (failureCount, error) => {
                if (error instanceof ApiError && error.httpStatus >= 400 && error.httpStatus < 500)
                    return false;
                return failureCount < 2;
            },
        },
        mutations: {
            onError: (error) => {
                if (error instanceof SessionExpiredError) {
                    useAuthStore.getState().clear();
                    void router.navigate({ to: '/login' });
                }
            },
        },
    },
});

export function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
            <Toaster richColors />
        </QueryClientProvider>
    );
}
